// --- React & Redux
import React from 'react';
import { useDispatch } from 'react-redux';
import { navigate } from '@reach/router';
// --- Pages
import { Login } from './clearances/pages/Login';
import { AuthorizedApp } from 'auth/AuthorizedApp';
// --- Authentication & Validation
import { AuthProvider } from 'auth/AuthProvider';
import { AuthVerify } from 'auth/AuthVerify/AuthVerify';
// --- Utilities
import { resetActiveUser } from './clearances/utils/localStorageService';
// --- Redux Actions
import { logout } from './clearances/store/auth';

/**
 * Core Component
 *
 * This component serves as the main entry point for the application.
 * It initializes the authentication provider and handles user logout.
 *
 * @component
 * @returns {JSX.Element} The main application layout with authentication handling.
 */
export function Core() {
    const dispatch = useDispatch();

    // Function to handle user logout
    function logOut() {
        resetActiveUser();
        dispatch(logout());
        navigate('/login');
    }

    // Render the application layout
    return (
        <div id="app" className="d-flex flex-column min-vh-100">
            <AuthProvider LoginComp={Login} AppComp={AuthorizedApp} />
            <AuthVerify logOut={logOut} />
        </div>
    );
}
